// extracted by mini-css-extract-plugin
export var oProblem = "problem-module--o-problem--23BQl";
export var lContent__inner = "problem-module--l-content__inner--N706i";
export var oProblem__list = "problem-module--o-problem__list--3gFn2";
export var oProblem__decorationCharactor = "problem-module--o-problem__decoration--charactor--1nvse";
export var oProblem__decorationOnayami = "problem-module--o-problem__decoration--onayami--3yj1o";
export var visible = "problem-module--visible--24dNK";
export var problem__list = "problem-module--problem__list--1PHDB";
export var standby = "problem-module--standby--1Tvg-";